module.exports = __webpack_public_path__ + "static/media/x_icon.06a55bec.svg";